import { Component, Input, OnDestroy } from '@angular/core';
import { VeritasMessage } from '@veritas-dumpsters/models/dumpster-event-detail';
import { DumpsterService } from '@veritas-dumpsters/services/dumpster.service';
import { CommonHelper } from '@veritas-shared/helpers/common.helper';
import { ConstantHelper } from '@veritas-shared/helpers/constant.helper';
import { PayloadType } from '@veritas-shared/models/entities/payload-type';
import { FileContent } from '@veritas-shared/models/file-content';
import { ConvertorService } from '@veritas-shared/services/convertor.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-event-export',
  templateUrl: './event-export.component.html',
  styleUrls: ['./event-export.component.scss']
})
export class EventExportComponent implements OnDestroy {
  private download$ = new Subscription();
  
  @Input() public event: VeritasMessage = {} as VeritasMessage;
  @Input() public payloadTypes: PayloadType[] = [];

  constructor (
    public constantHelper: ConstantHelper,
    private dumpsterService: DumpsterService,
    private commonHelper: CommonHelper,
    private convertorService: ConvertorService
  ) {}
  
  ngOnDestroy(): void {
    this.download$.unsubscribe();
  }

  public readonly setCopy = () => {
    this.convertorService.setCopyOnClipboard(this.event);
  }

  public readonly downloadFile = (): void => {
    this.download$ = this.dumpsterService
      .downloadDumpsterEventDetail(this.event)
      .subscribe((res: FileContent) => {
        if (!res) return;
        this.commonHelper.downloadAttachment(res);
      });
  }
}
